/**
 * Created by stonewang on 2017/8/17.
 */
import React from 'react';
import { Modal, Input, message } from 'antd';
import PropTypes from 'prop-types';
import {add, update} from '../service/remark/remark'
import './style.css';
const { TextArea } = Input;


class RemarkModal extends React.Component {
  state = {
    visible: false,
    text: '',
  };
  showModal = () => {
    if(this.props.isEdit && this.props.editData){
      this.setState({
        visible: true,
        text: this.props.editData.content,
      });
    }else{
      this.setState({
        visible: true,
        text: '',
      });
    }
  };
  handleOk = (e) => {
    const self = this;
    const {entityId, entityType} = this.props;
    if(this.props.onSuccess){
      this.props.onSuccess();
    }

    let obj = {};
    obj['relatedTableId'] = entityId;
    obj['content'] = self.state.text;

    switch (entityType){//1-渠道（dms_channel）；2-渠道联系人（dms_contacts）；3-门店（dms_shop）；4-门店店员（dms_seller)
      case 'channel':
        obj['relatedTableType'] = 1;
        break;
      case 'linkman':
        obj['relatedTableType'] = 2;
        break;
      case 'store':
        obj['relatedTableType'] = 3;
        break;
      case 'staff':
        obj['relatedTableType'] = 4;
        break;
      default:
        break;
    }
    if(!obj.relatedTableType){
      message.error('entityType是一个无效的值');
    }
    if(this.props.isEdit && this.props.editData && this.props.editData.id){
      update({...obj, id:this.props.editData.remarkId}).then(res=>{
        if(res.status){
          self.setState({
            visible: false,
          });
          if(self.props.onEditDone){
            self.props.onEditDone();
          }
        }
        message[res.status ? 'success' : 'error'](res.message);
      })
    }else{
      add({...obj}).then(res=>{
        if(res.status){
          self.setState({
            visible: false,
          });
          if(self.props.onSuccess){
            self.props.onSuccess();
          }
        }
        message[res.status ? 'success' : 'error'](res.message);
      })
    }
  };
  handleCancel = (e) => {
    this.setState({
      visible: false,
    });
  };
  changeHandle = (e) => {
    this.setState({ text: e.target.value });
  };
  render () {
    return <Modal
      title="新建备注"
      visible={this.state.visible}
      onOk={this.handleOk}
      onCancel={this.handleCancel}
    >
      <TextArea onChange={this.changeHandle}
                value={this.state.text}
                rows={4} />
    </Modal>
  }
}
RemarkModal.propTypes = {
  entityId: PropTypes.any.isRequired,
  entityType: PropTypes.string.isRequired,
  onSuccess: PropTypes.func,
  onEditDone: PropTypes.func,
  isEdit: PropTypes.bool,
  editData: PropTypes.object,
};
export default RemarkModal;


// WEBPACK FOOTER //
// ./src/components/remarkModal.js